export default __webpack_public_path__ + "static/SuisseIntl-Medium-WebS-5f8977167a12aefd8a60b203fd395818.ttf";